__turbopack_context__.v({
  "gc": "styles-module-scss-module__lsESOW__gc",
  "root": "styles-module-scss-module__lsESOW__root",
  "sc": "styles-module-scss-module__lsESOW__sc",
  "text": "styles-module-scss-module__lsESOW__text",
});
